import React from 'react';

export function DashboardSkeleton() {
  return (
    <div className="flex-1 content-stretch gap-1 grid grid-rows-[1fr_auto_auto] min-h-0">
      <div className="gap-1 grid grid-cols-2 sm:grid-cols-4 min-h-0">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
          <div key={item} className="bg-white p-1 border border-gray-200 rounded animate-pulse">
            <div className="flex justify-between mb-0.5">
              <div className="bg-gray-200 rounded w-12 h-2.5" />
              <div className="bg-gray-200 rounded w-5 h-5" />
            </div>
            <div className="bg-gray-200 mb-0.5 rounded w-10 h-3" />
            <div className="bg-gray-200 rounded h-2" />
          </div>
        ))}
      </div>
      <div className="gap-1 grid grid-cols-1 lg:grid-cols-2 min-h-0">
        <div className="bg-white p-1.5 border border-gray-200 rounded">
          <div className="bg-gray-200 mb-1 rounded w-12 h-2" />
          <div className="bg-gray-200 rounded h-12" />
        </div>
        <div className="bg-white p-1.5 border border-gray-200 rounded">
          <div className="bg-gray-200 mb-1 rounded w-12 h-2" />
          <div className="bg-gray-200 rounded h-12" />
        </div>
      </div>
      <div className="bg-gray-100 rounded h-5 animate-pulse" />
    </div>
  );
}
